module.exports = __webpack_public_path__ + "static/media/RadioSelect.4040c7ea.svg";